class DosespotUpdateButtonController {
  constructor($rootScope, toastr, Dosespot, Utils) {
    'ngInject';

    Object.assign(this, {
      $rootScope,
      toastr,
      Dosespot,
      Utils
    });
    this.foundDosespotData = true;
    this.checkingDosespot = false;
  }

  checkDosespot() {
    this.checkingDosespot = true;

    this.Dosespot.updatedDosespotInfo(this.visit.id)
      .then(({ data }) => {

        this.checkingDosespot = false;
        this.foundDosespotData = true;

        this.toastr.success('Dosespot information updated for this visit.');
        this.$rootScope.$broadcast('tab:selected:rxhistory', true);

        this.visit.has_med_history = data.has_med_history;
        this.visit.num_allergies = data.num_allergies;
        this.visit.num_external_prescriptions = data.num_external_prescriptions;
        this.visit.num_internal_prescriptions = data.num_internal_prescriptions;
      })
      .catch(({ data: err }) => {

        this.checkingDosespot = false;
        this.foundDosespotData = false;
        this.toastr.error('There was an error getting Dosespot information. Please try again later.');
      });
  }

  getButtonClasses() {

    if (this.visit.num_allergies == null || this.visit.num_external_prescriptions == null || this.visit.num_internal_prescriptions == null) {
      return "btn btn-danger";
    }
    if (this.visit.num_allergies != 0 || this.visit.num_external_prescriptions != 0) {
      return "btn btn-danger";
    }
    if (this.visit.num_allergies == 0 && this.visit.num_external_prescriptions == 0 && this.visit.num_internal_prescriptions != 0) {
      //return "btn btn-warning";
      return "btn btn-yellow-dosespot";
    }
    // if any other combination ==> all three options are zero:
    return "btn btn-grey-outline";
  }

  getButtonLabel() {

    if (this.checkingDosespot) {
      return "Checking";
    } else {
      if (!this.foundDosespotData) {
        return "Check Dosespot (No Data)";
      } else {
        if (this.visit.has_med_history) {
          return "Check Dosespot (Has Med History)";
        } else {
          return "Check Dosespot (No Med History)";
        }
      }
    }
  }
}

DosespotUpdateButtonController.$inject = ["$rootScope", "toastr", "Dosespot", "Utils"];
angular.module('pims').component('dosespotUpdateButton', {
  template: `
      <button
        class="{{ vm.getButtonClasses() }}"
        ng-click="vm.checkDosespot();"
        loading-when="vm.checkingDosespot"
        loading-type="primary"
        ng-disabled="vm.isDisabled"
        style="width: 231px; background-color: #ff5f1c">
        {{ vm.getButtonLabel() }}
      </button>
    `,
  controller: DosespotUpdateButtonController,
  controllerAs: 'vm',
  bindings: {
    defaultClasses: '<',
    errorClasses: '<',
    visit: '<',
    isDisabled: '<',
    customClasses: '<'
  }
});
